<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="rtRoutes"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工艺路线编号">
            <el-input v-model.trim="filter.routeNo" placeholder="请输入工艺路线编号" clearable/>
          </el-form-item>
          <el-form-item label="工艺路线名称">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
          <el-form-item label="工艺路线状态">
            <el-select v-model="filter.status" placeholder="请选择工艺路线状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.detailAuth" type="primary" @click="$refs.rtRouteEdit.open(scope.row, 1)">详情</el-button>
      </template>
    </viewTable>
    <rt-route-edit ref="rtRouteEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RtRouteEdit from "./RtRouteEdit";
  export default {
    components: { viewTable, RtRouteEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(716),
          editAuth: this.$auth(717),
          delAuth: this.$auth(718),
          detailAuth: this.$auth(719),
        },
        filter: {},
        columnsProperty: [
          {
            key: "routeNo",
            width: 100,
            align: "center",
          },
          {
            key: "routeName",
            minWidth: 150,
          },
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "note",
            width: 180,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.rtRouteEdit.open(row);
      },

      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "rtRoutes", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
